import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/esm/Card";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import Button from "react-bootstrap/esm/Button";
import toast, { Toaster } from "react-hot-toast";
import BackToGameList from "../../utils/BackToGameList";

function WordHunter() {
  const [play, setPlay] = useState(false);
  const [pregame, setPregame] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [timeoutTrigger, setTimeoutTrigger] = useState(false);
  const [time, setTime] = useState(0);
  const [cCount, setCCount] = useState(-1);
  const [astInput, setAstInput] = useState("");
  const [intervalID, setIntervalID] = useState(0);
  const [newKey, setNewKey] = useState({
    key: " ",
    code: 32,
  });
  const [wordData, setWordData] = useState({});
  const [wrongLetterArray, setWrongLetterArray] = useState([]);
  const [attempts, setAttempts] = useState(26);

  const handleWordData = async () => {
    const response = await makeGetRequest(urls.wordHunter, "", true);
    let rnd = Math.floor(Math.random() * response.data.length);
    setWordData(response.data[rnd]);
    setGameOver(false);
    setTimeoutTrigger(false);
  };

  const resetGame = () => {
    setWordData({});
    handleWordData();
    setGameOver(false);
    setWrongLetterArray([]);
    setCCount(0);
    setAttempts(26);
    setAstInput("");
  };

  useEffect(() => {
    handleWordData();
  }, []);

  useEffect(() => {
    if (wordData.word) {
      handleText(' ');
    }
  }, [wordData]);

  useEffect(() => {
    if (play) {
      const intervalId = setInterval(() => {
        if (play) {
          setTime((prevSeconds) => prevSeconds - 1);
        }
      }, 1000);
      setIntervalID(intervalId);
      return () => clearInterval(intervalId);
    }
  }, [play]);

  useEffect(() => {
    if (timeoutTrigger === true) {
      setPlay(true);
      setTime(120);
      setPregame(false);
    }
  }, [timeoutTrigger]);

  const handleText = (event) => {
    let re = [];
    if (event) {
      let k = newKey.key.toLowerCase();
      console.log(isNaN(k))
      if (isNaN(k) || k == ' ') {
        if ((newKey.code < 96 && newKey.code > 64) || newKey.code == 32) {
          let val = [...astInput.split("")];
          if (val.findIndex((letter) => letter === k) >= 0) {
            toast("You have used this character and it is in the word.", {
              duration: 3000,
              position: "right",
            });
          } else {
            let word = wordData.word;
            let wrongCounter = 0;
            let correctCounter = 0;
            word = word.toLowerCase();
            let wordArray = [...word.split("")];
            if (wrongLetterArray.findIndex((letter) => letter === k) === -1) {
              for (let i = 0; i < wordData.word.length; i++) {
                if (val[i] !== wordArray[i]) {
                  if (k !== wordArray[i]) {
                    wrongCounter = wrongCounter + 1;
                    re[i] = "*";
                  } else {
                    re[i] = k;
                    correctCounter = correctCounter + 1;
                  }
                } else {
                  correctCounter = correctCounter + 1;
                  re[i] = val[i];
                }
              }
              if (wrongCounter === re.length - cCount) {
                setAttempts((curAttempts) => curAttempts - 1);
                setWrongLetterArray((prevLetters) => [...prevLetters, k]);
              }
              setAstInput(String(re).replaceAll(",", ""));
              setCCount(correctCounter);
            } else {
              toast("You have used this character already.", {
                duration: 3000,
                position: "right",
              });
            }
          }
        } 
        // else {
        //   toast("There are no special characters in Word Hunter.", {
        //     duration: 3000,
        //     position: "right",
        //   });
        // }
      } else {
        toast("There are no numbers in Word Hunter.", {
          duration: 3000,
          position: "right",
        });
      }
    } else {
      let ast = "";
      for (let i = 0; i < wordData.word.length; i++) {
        ast = ast + "*";
      }
      setAstInput(ast);
    }
  };

  useEffect(() => {
    if (wordData.word !== undefined) {
      if (wordData.word.length - cCount === 0) {
        toast("Congratulations that is the correct word!.", {
          duration: 3000,
          position: "right",
        });
        setGameOver(true);
      }
    }
  }, [cCount]);

  const hint = () => {
    let correctWord = wordData.word.toLowerCase();
    let userGuess = astInput.split("");
    let correctedLetter = "";
    let newCount = 0;
    correctWord = correctWord.split("");
    for (let i = 0; i < correctWord.length; i++) {
      if (correctWord[i] !== userGuess[i]) {
        correctedLetter = correctWord[i];
        break;
      }
    }
    for (let i = 0; i < correctWord.length; i++) {
      if (
        correctedLetter !== userGuess[i] &&
        correctedLetter === correctWord[i]
      ) {
        userGuess[i] = correctedLetter;
        newCount = newCount + 1;
      }
    }
    let set = String(userGuess).replaceAll(",", "");
    setCCount((prevCount) => prevCount + newCount);
    setAstInput(set);
  };

  return (
    <>
      <BackToGameList />
      <Card style={{ marginTop: "50px" }}>
        <Card.Header>
          <h1 style={{ textAlign: "center" }}>
            {!gameOver
              ? wordData.phrase
              : wordData.word + " was the correct word!"}
          </h1>
        </Card.Header>
        <Card.Body>
          <Card style={{ padding: "25px" }}>
            {!gameOver ? (
              <>
                <Row>
                  <Col>Attempts Left: {attempts}</Col>
                  <Col>
                    <div style={{ textAlign: "right" }}>
                      <Button
                        variant="warning"
                        onClick={() => hint()}
                        style={{ width: "100px", marginBottom: "20px" }}
                      >
                        Hint
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Row>
                    <Col style={{ textAlign: "center", fontSize: '60px' }}>
                        <input
                          type="text"
                          onChange={(e) => handleText(e)}
                          onKeyDown={(e) =>
                            setNewKey({ key: e.key, code: e.keyCode })
                          }
                          value={astInput}
                        ></input>
                    </Col>
                  </Row>
                </Row>
                <Row>
                  <Row>
                    <div
                      style={{
                        textAlign: "center",
                        borderBottom: "#333 solid 1px",
                        fontSize: "30px",
                      }}
                    >
                      Used Letters:
                    </div>
                  </Row>
                  <Col style={{ fontSize: "24px", textAlign: "center" }}>
                    <b style={{ color: "red" }}>
                      {wrongLetterArray.map((l) => {
                        return " " + l;
                      })}
                    </b>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <h3>
                  Congratulations! You've successfully completed the word!
                  Please select "Next" to proceed to the next round of Word
                  Hunter.
                </h3>
                <Button onClick={() => window.location.reload()}>Next</Button>
              </>
            )}
          </Card>
        </Card.Body>
      </Card>
      <Toaster />
    </>
  );
}

export default WordHunter;
